import React, { useState } from 'react';
import { Stack, Cluster, Button, IconButton, List, Icon } from '@iqueue/iq-ui';
import Modal from '../ui/Modal';
import Field from '../ui/Field';
import { agentInfo, agentIcon } from '../../lib/agentRegistry';

/** Room membership editor: real member list from the server, add/remove by handle. */
export default function RoomMembersDialog({ open, onClose, room, members, agents, canManage, onAddMember, onRemoveMember }) {
  const [newMember, setNewMember] = useState('');
  if (!room) return null;

  const memberIds = new Set((members || []).map(m => m.participant));
  const addableAgents = (agents || []).filter(a => !memberIds.has(a.id));

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`Участники — ${room.name || room.id}`}
      actions={<Button variant="text" onClick={onClose}>Закрыть</Button>}
    >
      <Stack gap={200}>
        <List>
          {(members || []).map(m => {
            const isAgent = m.participant_type === 'agent';
            const info = isAgent ? agentInfo(m.participant) : null;
            return (
              <List.Item
                key={`${m.participant_type}:${m.participant}`}
                leading={<Icon name={isAgent ? info.icon : 'person'} />}
                supporting={isAgent ? (info.description || 'агент') : 'человек'}
                // `trailing`, а не `trailingAction`: у строки нет основного
                // действия, а `trailingAction` без него библиотека молча
                // выбрасывает — кнопка «Убрать» просто не рендерилась.
                trailing={canManage
                  ? <IconButton icon="close" size="xs" tone="error" label={`Убрать @${m.participant}`} onClick={() => onRemoveMember(m.participant)} />
                  : undefined}
              >
                @{m.participant}
              </List.Item>
            );
          })}
        </List>
        {canManage && (
          <>
            {addableAgents.length > 0 && (
              <Cluster gap={100}>
                {addableAgents.map(a => (
                  <Button key={a.id} size="xs" variant="tonal" onClick={() => onAddMember(a.id)}
                    startIcon={<Icon name={agentIcon(a.avatar)} />}>
                    @{a.id}
                  </Button>
                ))}
              </Cluster>
            )}
            <Cluster gap={100} align="end">
              <Field label="Добавить по handle" value={newMember} onChange={setNewMember} />
              <Button disabled={!newMember.trim()} onClick={() => { onAddMember(newMember.trim()); setNewMember(''); }}>Добавить</Button>
            </Cluster>
          </>
        )}
      </Stack>
    </Modal>
  );
}
